// reducer.ts
import {
    MM_RFQ_FORM_DATA,
    RESET_MM_RFQ_FORM_DATA,
    UPDATE_MM_RFQ_FORM_ITEM,
    UPDATE_SELECTED_VENDORS
} from "./actionTypes";

interface MMFormDataState {
    mmRfqFormDataToStore: any[];
}

const initialState: MMFormDataState = {
    mmRfqFormDataToStore: []
};

const mmRfqFormDataReducer = (
    state = initialState,
    action: any
): MMFormDataState => {
    switch (action.type) {
        case MM_RFQ_FORM_DATA:
            return { ...state, mmRfqFormDataToStore: action.payload };

        case RESET_MM_RFQ_FORM_DATA:
            return { ...state, mmRfqFormDataToStore: [] };

        case UPDATE_MM_RFQ_FORM_ITEM: {
            const updatedData = [...state.mmRfqFormDataToStore];

            updatedData[0] = {
                ...updatedData[0],
                Part_Details: updatedData[0].Part_Details.map((item) => {
                    if (item.Part_Number === action.payload.Part_Number) {
                        return {
                            ...item,
                            Target_Price: action.payload.Target_Price,
                            Total_Order_Value: action.payload.Total_Order_Value,
                            Upload_Drawing: action.payload.Upload_Drawing,
                            selectedVendors: action.payload.selectedVendors,
                            selectedVendorsID: action.payload.selectedVendorsID
                        };
                    }
                    return item;
                })
            };
            return { ...state, mmRfqFormDataToStore: updatedData };
        }

        default:
            return state;
    }
};

export default mmRfqFormDataReducer;
